import { render, staticRenderFns } from "./JVxeToolbar.vue?vue&type=template&id=ecf834c4"
import script from "./JVxeToolbar.vue?vue&type=script&lang=js"
export * from "./JVxeToolbar.vue?vue&type=script&lang=js"
import style0 from "./JVxeToolbar.vue?vue&type=style&index=0&id=ecf834c4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports